import { EProductPlanPaymentInterval } from "@devowl-wp/api-real-commerce";
import { formatNumber } from "./getDecimalSeparator.js";
import { __ } from "./i18n.js";
import { localizePaymentInterval } from "../others/localizePaymentInterval.js";
const CURRENCY_SYMBOLS = {
    EUR: "€",
    USD: "$"
};
function formatAmount({ amount, currency, paymentInterval, prefix = "", taxTreatment }) {
    const currencySymbol = CURRENCY_SYMBOLS[currency] ?? currency;
    const intervalSuffix = paymentInterval && paymentInterval !== EProductPlanPaymentInterval.OneTime ? ` / ${localizePaymentInterval(paymentInterval)}` : "";
    const taxSuffix = taxTreatment ? ` ${taxTreatment === "net" ? __("net") : __("gross")}` : "";
    return `${prefix}${formatNumber(amount)} ${currencySymbol}${taxSuffix}${intervalSuffix}`;
}
function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] ?? currency;
}
export { formatAmount, getCurrencySymbol, CURRENCY_SYMBOLS };
